// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"e5a20be9","43":"cadfa029","213":"17759adc","239":"b04183e4","377":"b5d14f6b","453":"b647f534","455":"13b98e41","559":"1e288efb","950":"c6b570ac"}[chunkId] + ".chunk.js";
};